/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M17.1387 2.643a.75.75 0 0 0-1.2774-.786l-12 19.4999a.75.75 0 0 0 1.2774.7862l12-19.5ZM23.8887 2.643a.75.75 0 0 0-1.2774-.786l-12 19.4999a.75.75 0 1 0 1.2774.7862l12-19.5Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.25 9C3.4926 9 4.5 7.9927 4.5 6.75c0-1.2426-1.0074-2.25-2.25-2.25S0 5.5074 0 6.75C0 7.9927 1.0074 9 2.25 9Zm0-1.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM4.5 14.25c0 1.2427-1.0074 2.25-2.25 2.25S0 15.4927 0 14.25C0 13.0074 1.0074 12 2.25 12s2.25 1.0074 2.25 2.25Zm-1.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'CUrl'
);
